import React from 'react'
import CreateNewModal from '../../UI/CreateNewModal'
import { ModalButton } from '../../UI/ModalButton'
import { WidgetContent } from '@duik/it'

const ViewNotesModal = props => {
  return (
    <CreateNewModal title="View Notes" handleCloseModal={props.handleCloseModal}>
      <WidgetContent style={{ height: '100%' }}>
        <textarea
          style={{
            height: '379px',
            width: '100%',
            resize: 'none',
            border: '1px solid #E2E5ED',
            borderRadius: '4px',
            fontSize: '14px'
          }}
          value={props.editLoadDetail.notes}
        />
      </WidgetContent>
      <WidgetContent style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <div style={{ width: '83px' }}>
          <ModalButton success onClick={props.handleCloseModal} name="OK" />
        </div>
      </WidgetContent>
    </CreateNewModal>
  )
}

export default ViewNotesModal
